module.exports = __webpack_public_path__ + "img/Press_Release_KasPro_x_Nucash.ac1c0d30.jpeg";